import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://gznwnelgsrvyiyxnsnyc.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd6bnduZWxnc3J2eWl5eG5zbnljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIzNjAwMTcsImV4cCI6MjA3NzkzNjAxN30.UNON3rNmiuKdr0v5E3MIEJzrN-KagWpf1cYumPFrDDo'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Export the anon key for use in Edge Function calls
export const SUPABASE_ANON_KEY = supabaseAnonKey
export const SUPABASE_URL = supabaseUrl 